import { useMemo } from "react";
import { useStore } from "react-redux";

import { IndustryEnum } from "../../types/api-schema";
import { PlacesSearchEngine, StopsSearchEngine } from "../search";

import useAppSelector from "./useAppSelector";

import type { SearchEngine } from "../search";

/**
 * Returns the search engines available for the current customer:
 * stops (mobility customers only, prioritized) and places (all customers).
 */
const useSearchEngines = (mots?: string): SearchEngine[] => {
  const store = useStore();
  const industry = useAppSelector((state) => {
    return state.app.organization?.industry || state.app.config.industry;
  });
  const settings = useAppSelector((state) => {
    return state.app.config.settings;
  });
  const prefAgencies = useAppSelector((state) => {
    return state.app.prefAgencies;
  });
  const geoapifyKey = useAppSelector((state) => {
    return state.app.geoapifyKey as string;
  });

  return useMemo(() => {
    const engines: SearchEngine[] = [];
    if (industry === IndustryEnum.Transport) {
      engines.push(
        new StopsSearchEngine({
          params: {
            bbox: settings?.stops_api_bbox || "",
            mots: mots || "",
            prefagencies: settings?.stops_api_prefagencies || prefAgencies,
          },
          priority: 0,
          store,
        }),
      );
    }
    if (geoapifyKey) {
      engines.push(
        new PlacesSearchEngine({ apiKey: geoapifyKey, priority: 1 }),
      );
    }
    return engines;
  }, [industry, geoapifyKey, mots, prefAgencies, settings, store]);
};

export default useSearchEngines;
